export const DEAL_TYPE = {
  primary: "primary",
  secondary: "secondary"
};

export const CREDIT_TYPE = {
  non_expired: "credits.initial_credits",
  primary: "credits.title_consume_bar_standard",
  secondary: "credits.label_extra",
  extra: "credits.count_label_standard_excess"
};

export const CREDIT_TYPE_OPTIONS = [
  { id: null, label: "credits.all" },
  { id: "non_expired", label: "credits.initial_credits" },
  { id: "primary", label: "credits.title_consume_bar_standard" },
  { id: "secondary", label: "credits.label_extra" },
  { id: "extra", label: "credits.count_label_standard_excess" }
];

export const CICLE_DURATION = {
  90: "credits.cicle.quarterly",
  180: "credits.cicle.semester",
  365: "credits.cicle.yearly",
  730: "credits.cicle.biennial",
  1095: "credits.cicle.triennial",
  30: "credits.cicle.monthly"
};

export const CREDIT_TYPE_EXTRACT = {
  MONITORED: "monitored",
  SECONDARY: "secondary",
  EXTRA: "extra"
};
